'use strict';
const SEND_INTERVAL = 2000;
module.exports = function WebSocketShimBufferedSender({webSocketShim, navigatorShim}) {
	let sendInProgress = false;
	const self = this,
		buffer = [],
		sendMessages = () => {
			const last = buffer.length,
				toSend = buffer.slice(0, last),
				dataToSend = toSend.map(item => item.data);
			if (sendInProgress || !toSend.length || !webSocketShim.isOpen()) {
				return;
			}
			sendInProgress = true;
			try {
				webSocketShim.send(dataToSend);
				toSend.forEach(item => item.resolve());
			} catch (e) {
				toSend.forEach(item => item.reject(e));
			}
			buffer.splice(0, last);
			sendInProgress = false;
		};

	navigatorShim.setInterval(sendMessages, SEND_INTERVAL);

	Object.keys(webSocketShim).forEach(prop => {
		self[prop] = webSocketShim[prop];
	});

	self.send = (data) => {
		return new Promise((resolve, reject) => {
			buffer.push({data, resolve, reject});
		});
	};



};
